import React, { useEffect, useState,  } from 'react';
import { useSelector } from 'react-redux';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalCloseButton,
  ModalBody,
  Text,
  Link,
  Icon,
  VStack,
  HStack,
} from '@chakra-ui/react';
import { InfoIcon } from '@chakra-ui/icons';
import httpInjectorService from 'services/http-injector.service';
import { toast } from 'react-toastify';
 
const SprintModal = ({ isOpen, onClose, taskdetails, projectId, getTaskBoardDetails, Applyfilters  }) => {
  const [sprints, setSprints] = useState([]);
  useEffect(() => {
    if (isOpen && projectId) {
      getsprintlist();
    }
  }, [isOpen, projectId]);
 
  const getsprintlist = async () => {
  try {
    const response = await httpInjectorService.getsprintList(projectId);
    if (response.status === 'success') {
      const activeSprints = response.data?.active_sprints || [];
      setSprints(activeSprints); 
    } else {
      toast({
        title: 'Error',
        description: response.message || 'Failed to fetch sprint list.',
        status: 'error',
        duration: 3000,
        isClosable: true,
      });
    }
  } catch (error) {
    toast({
      title: 'Error',
      description: 'Something went wrong while fetching sprints.',
      status: 'error',
      duration: 3000,
      isClosable: true,
    });
  }
};
 
 
  // ✅ Handle sprint assignment
  const handleAssignToSprint = async (sprintId) => {
    try {
      const payload = {
        project_id: projectId,
        issue_id: taskdetails.issue_id,
        issue_type_id:taskdetails.issue_type_id,
        sprint_id: sprintId,
      };
 
      const response = await httpInjectorService.updateTaskwithSprint(payload);
      if (response.status === 'success') {
        toast.success(response.message, {
          position: 'top-right',
          autoClose: 3000,
        });
        
        onClose();
          getTaskBoardDetails();
      
      } else {
        toast.error(response.message, {
          position: 'top-right',
          autoClose: 3000,
        });
      }
    } catch (error) {
    throw error;
    }
  };
 
  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered size="sm">
      <ModalOverlay />
      <ModalContent
        p={4}
        borderRadius="md"
        boxShadow="lg"
        bg="white"
        fontSize="14px"
      >
        <ModalCloseButton />
        <ModalBody>
          <HStack align="start" spacing={3}>
            <Icon as={InfoIcon} color="purple.500" boxSize={5} mt={1} />
 
            <VStack align="start" spacing={2}>
              <Text fontWeight="bold">
                Changes are saved, but work item isn’t visible
              </Text>
              <Text color="gray.600">
                For work item{' '}
                <Link color="blue.500" href="#" fontWeight="medium">
                  {taskdetails?.issue_key || `TASK-${taskdetails?.task_id}`}
                </Link>{' '}
                to be visible, it must match your project and filters, and have
                a status that’s assigned to the board.
              </Text>
 
              <HStack spacing={4} pt={1} flexWrap="wrap">
                {/* <Link color="blue.500" fontWeight="medium" href="#">
                  View
                </Link> */}
 
                {/* ✅ Dynamic Sprint List */}
                {sprints.map((sprint) => (
                  <Link
                    key={sprint.sprint_id}
                    color="blue.500"
                    fontWeight="medium"
                    cursor="pointer"
                    onClick={() => handleAssignToSprint(sprint.sprint_id)}
                  >
                    Add to {sprint.sprint_name}
                  </Link>
                ))}
              </HStack>
            </VStack>
          </HStack>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};
 
export default SprintModal;